import loadAppManifest from './manifest-loader';
import loadAppAssets from './assets-loader';
import type { MicroAppModule, TranslationEntry } from '../shared/types';
import type { IEventBus } from '@shore/types';

export default async function preLoad(
  name: string,
  locale: string,
  eventBus?: IEventBus
): Promise<{ App: MicroAppModule; translationDataList: TranslationEntry[] }> {
  const manifest = await loadAppManifest(name, eventBus);
  return loadAppAssets(name, manifest, locale);
}
